import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Tooltip } from 'react-bootstrap';

/* Function */
import ObjGeneral from '../function/';
/* Local store */
import { localStoreFN } from '../../store/localStorage';
/* Actions */
import * as detailWaitingTimesActions from '../../actions/detail_waiting_times/index';

/* Components */
import Header from '../../components/detail_waiting_times/header';
import WaitingTimesHistogramGraph from '../../components/detail_waiting_times/waitingTimesHistogramGraph';
import AvgDurationByArriveTimeGraph from '../../components/detail_waiting_times/avgDurationByArriveTimeGraph';
import WaitingTimesTable from '../../components/detail_waiting_times/waitingTimesTable';
import TitleMain from '../../components/common/titleMain';
import Label from '../../components/common/label';
import SimpleIndicator from '../../components/common/indicators/simpleIndicator';
import Avatar from '../../components/common/avatar';
import Loading from '../../components/common/loading';
import Message from '../../components/common/message';
import AvatarImg from '../../../../public/images/faena.png';
import Expired from '../expired/index';

class DetailWaitingTimes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startHourFilterValue: [''],
      waitingLengthFilterValue: [''],
      startHourFilterString: '',
      waitingLengthFilterString: '',
      geozone: 0
    };
  }

  componentWillUnmount() {
    this.props.actions.resetDetailWaitingTimes();
  }

  componentWillMount() {
    const permits = localStoreFN().getItem('permits');
    const permit = permits.includes('waitingtimes');
    if (!permit) {
      this.props.history.push('/dashboard/authorization');
    }
  }

  async componentDidMount() {
    const permits = localStoreFN().getItem('permits');
    const permit = permits.includes('waitingtimes');
    if (permit) {
      if (this.props.setting) {
        const obj = JSON.parse(this.props.setting.value);
        if (obj.generalSetting.views.includes('waitingtimes')) {
          const dateStart = this.props.filters.date.fechaStartFinal || null;
          const dateEnd = this.props.filters.date.fechaEndFinal || null;
          const tags = this.props.filters.tags;
          const geozone = this.props.filters.geozone ? this.props.filters.geozone.id : null;
          this.state.geozone = geozone;

          await this.props.actions.fetchDetailWaitingTimesApi({
            dateStart,
            dateEnd,
            tags,
            geozone: geozone
          });
        } else {
          this.props.history.push('/dashboard/authorization');
        }
      }
    } else {
      this.props.history.push('/dashboard/authorization');
    }
  }

  handleStartHourFilterSubmit = e => {
    this.setState({
      startHourFilterValue: e.target.value.split(';'),
      startHourFilterString: e.target.value
    });
  };

  handleWaitingLengthFilterSubmit = e => {
    this.setState({
      waitingLengthFilterValue: e.target.value.split(';'),
      waitingLengthFilterString: e.target.value
    });
  };

  handleSubmit = async obj => {
    /* GROUP */
    const format = this.props.language.account.date.format;
    /* TAGS */
    const tags = ObjGeneral.getTags(obj);
    /* GEOZONE */
    let geozone = this.state.geozone;
    let geozoneText = null;
    if (obj.id == 'geozone') {
      geozone = Number.isInteger(obj.value) ? obj.value : 0;
      if (Number.isInteger(obj.value)) {
        geozoneText = this.props.filterGeozones.find(o => o.id === obj.value);
      } else {
        geozoneText = null;
      }
      this.setState({ geozone: geozone });
    }
    /* DATE */
    const date = ObjGeneral.getDate(obj, format);

    this.props.actions.setFilterDetailWaitingTimes({
      tags: tags,
      date: date,
      geozone: geozoneText
    });
    await this.props.actions.fetchDetailWaitingTimesApi({
      tags: tags,
      dateStart: date.fechaStartFinal,
      dateEnd: date.fechaEndFinal,
      geozone: geozone
    });
  };

  render() {
    if (this.props.setting) {
      const obj = JSON.parse(this.props.setting.value);
      const setting = ObjGeneral.getSetting({
        setting: obj.detailWaitingTimes,
        filter: this.props.filter,
        general: obj.generalSetting
      });
      const language = this.props.language ? this.props.language.filter : '';
      return (
        <section className="main full-height detail-waiting-times">
          <Header
            loadingFilter={this.props.loadingFilter}
            loadingFilterGeozones={this.props.loadingFilterGeozones}
            filters={this.props.filters}
            filter={setting.filter}
            filterGeozones={this.props.filterGeozones}
            date={this.props.dateMax[4]}
            handleSubmit={this.handleSubmit}
            language={language}
          />
          {this.props.loading ? (
            <Loading language={this.props.language} />
          ) : this.props.status === 401 ||
            this.props.statusTags === 401 ||
            this.props.statusGeozones === 401 ? (
            <Expired
              history={this.props.history}
              language={this.props.language ? this.props.language : ''}
            />
          ) : this.props.status === 200 &&
            this.props.statusTags === 200 &&
            this.props.statusGeozones === 200 ? (
            <div className="main-container">
              <div className="left-col">
                <div className="top-left-section">
                  <div className="vertical-container">
                    <section className="operation-info">
                      <Avatar width={130} src={`${AvatarImg}`} />
                      <section className="avg-times-wrapper">
                        <Label
                          label={this.props.language.detail_waiting_times.labels.avgPerVehicle}
                        />
                        <SimpleIndicator
                          value={this.props.datos.avgWaitingTimes}
                          valueFormat={{ type: 'NUMBER', format: 'hh:mm' }}
                        />
                      </section>
                    </section>
                  </div>
                </div>
                <section className="operation-waiting-times">
                  <TitleMain title={this.props.language.detail_waiting_times.title.traceability} />
                  <div className="operation-filters">
                    <Label
                      label={
                        this.props.language.detail_waiting_times.filters.startHour.toUpperCase() +
                        ':'
                      }
                    />
                    <div className="box-form islabel box170 inner-dashboard-input startHourSelect">
                      <select
                        id="group"
                        defaultValue={this.state.startHourFilterString}
                        onChange={this.handleStartHourFilterSubmit}
                      >
                        {Object.keys(
                          this.props.language.detail_waiting_times.filters.startHourOptions
                        ).map((key, i) => (
                          <option value={key} key={`group-${i}`}>
                            {this.props.language.detail_waiting_times.filters.startHourOptions[key]}
                          </option>
                        ))}
                      </select>
                    </div>
                    <Label
                      label={
                        this.props.language.detail_waiting_times.filters.waitingLength.toUpperCase() +
                        ':'
                      }
                    />
                    <div className="box-form islabel box170 inner-dashboard-input">
                      <select
                        id="group"
                        defaultValue={this.state.waitingLengthFilterString}
                        onChange={this.handleWaitingLengthFilterSubmit}
                      >
                        {Object.keys(
                          this.props.language.detail_waiting_times.filters.waitingLengthOptions
                        ).map((key, i) => (
                          <option value={key} key={`group-${i}`}>
                            {
                              this.props.language.detail_waiting_times.filters.waitingLengthOptions[
                                key
                              ]
                            }
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <WaitingTimesTable
                    language={this.props.language}
                    data={this.props.datos.waitingTimesList}
                    startHourFilter={this.state.startHourFilterValue}
                    waitingLengthFilter={this.state.waitingLengthFilterValue}
                  />
                </section>
              </div>
              <div className="right-col">
                <section className="avg-times-histogram">
                  <TitleMain
                    className={'second'}
                    title={this.props.language.detail_waiting_times.title.avgTimesHistogram}
                  />
                  <WaitingTimesHistogramGraph
                    data={this.props.datos.avgWaitingTimesDistribution}
                    tooltip={this.props.language.detail_waiting_times.graphTooltip}
                  />
                </section>
                <section className="avg-times-per-arrive">
                  <TitleMain
                    className={'second'}
                    title={this.props.language.detail_waiting_times.title.avgTimesPerArrive}
                  />
                  <AvgDurationByArriveTimeGraph
                    data={this.props.datos.avgWaitingTimesByStartHour}
                    tooltip={this.props.language.detail_waiting_times.graphTooltip}
                  />
                </section>
              </div>
              <Tooltip placement="top" id="pageTooltip" />
            </div>
          ) : this.props.status === 500 ||
            this.props.statusTags === 500 ||
            this.props.statusGeozones === 500 ? (
            <Message message={this.props.language.error.apiError500} />
          ) : (
            <Message message={this.props.language.error.apiError} />
          )}
        </section>
      );
    } else {
      return (
        <section className="main">
          <Message message={this.props.language.error.noSetting} />
        </section>
      );
    }
  }
}
const mapStateToProps = state => ({
  filter: state.reducer.tags.filter,
  statusTags: state.reducer.tags.status,
  loadingFilter: state.reducer.tags.loading,

  filterGeozones: state.reducer.geozones.filter,
  statusGeozones: state.reducer.geozones.status,
  loadingFilterGeozones: state.reducer.geozones.loading,

  language: state.reducer.dashboard.language,
  dateMax: state.reducer.dashboard.dateMax,
  setting: state.reducer.dashboard.setting,
  datos: state.reducer.detailWaitingTimes.datos,
  loading: state.reducer.detailWaitingTimes.loading,
  status: state.reducer.detailWaitingTimes.status,
  filters: state.reducer.detailWaitingTimes.filters
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(detailWaitingTimesActions, dispatch)
});

DetailWaitingTimes.propTypes = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DetailWaitingTimes);



// WEBPACK FOOTER //
// ./source/client/containers/detail_waiting_times/index.jsx